import React from 'react';
import ReactApexChart from 'react-apexcharts';

const DonutChart = ({ data }) => {
  // Add validation and debugging
  if (!data || data.length === 0) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '200px',
        padding: '20px 0'
      }}>
        <div style={{ textAlign: 'center', color: '#666' }}>
          No data available for chart
        </div>
      </div>
    );
  }

  const series = data.map((item) => item.proportion || 0);
  const id = data.map((item) => item.assetId || item.asset?.symbol || 'unknown');
  const labels = data.map((item) => item.asset ? item.asset.symbol : "Asset");

  // Ensure we have valid data
  if (series.every(val => val === 0)) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: '200px',
        padding: '20px 0'
      }}>
        <div style={{ textAlign: 'center', color: '#666' }}>
          All allocations are 0%
        </div>
      </div>
    );
  }

  const options = {
    dataLabels: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
    legend: {
      show: false,
    },
    labels: labels,
    chart: {
      type: 'donut',
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        }
      }
    }]
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      minHeight: '200px',
      padding: '20px 0'
    }}>
      <ReactApexChart options={options} series={series} type="donut" width="320" />
    </div>
  );
};

export default DonutChart;
